import countryList from "react-select-country-list";

// Shipping addresses carry the ISO country code and, for the US, the two-letter state code:
// the API picks the tax rate from them
const countries = countryList();
export const COUNTRY_OPTIONS = countries.getData();

export const US_STATES = [
  ["AL", "Alabama"], ["AK", "Alaska"], ["AZ", "Arizona"], ["AR", "Arkansas"], ["CA", "California"],
  ["CO", "Colorado"], ["CT", "Connecticut"], ["DE", "Delaware"], ["DC", "District of Columbia"], ["FL", "Florida"],
  ["GA", "Georgia"], ["HI", "Hawaii"], ["ID", "Idaho"], ["IL", "Illinois"], ["IN", "Indiana"], ["IA", "Iowa"],
  ["KS", "Kansas"], ["KY", "Kentucky"], ["LA", "Louisiana"], ["ME", "Maine"], ["MD", "Maryland"],
  ["MA", "Massachusetts"], ["MI", "Michigan"], ["MN", "Minnesota"], ["MS", "Mississippi"], ["MO", "Missouri"],
  ["MT", "Montana"], ["NE", "Nebraska"], ["NV", "Nevada"], ["NH", "New Hampshire"], ["NJ", "New Jersey"],
  ["NM", "New Mexico"], ["NY", "New York"], ["NC", "North Carolina"], ["ND", "North Dakota"], ["OH", "Ohio"],
  ["OK", "Oklahoma"], ["OR", "Oregon"], ["PA", "Pennsylvania"], ["RI", "Rhode Island"], ["SC", "South Carolina"],
  ["SD", "South Dakota"], ["TN", "Tennessee"], ["TX", "Texas"], ["UT", "Utah"], ["VT", "Vermont"],
  ["VA", "Virginia"], ["WA", "Washington"], ["WV", "West Virginia"], ["WI", "Wisconsin"], ["WY", "Wyoming"],
];

// Saved addresses may hold a code or a name
export const toCountryCode = (value) => {
  const text = String(value || "").trim();
  if (countries.getLabel(text.toUpperCase())) return text.toUpperCase();
  return countries.getValue(text) || "";
};

export const toUsStateCode = (value) => {
  const text = String(value || "").trim().toLowerCase();
  return US_STATES.find(([code, name]) => code.toLowerCase() === text || name.toLowerCase() === text)?.[0] || "";
};

export const countryName = (code) => countries.getLabel(String(code || "")) || code;
